import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { I18N_NAMESPACES, WINE_FLAVOURS_ITEMS_PER_ROW } from "../../../helpers/constants";
import flavourImagePlaceholder from "../../../assets/images/icons/strawberry.svg";
import {
  GetWine_wine as WineType,
  GetWine_wine_flavours as FlavourType,
  GetWine_wine_fruits as FruitType,
} from "../../../types/__generated__/GetWine";

import { SectionTitle, FlavourItemsWrapper, FlavourItem, FlavourItemImage, FlavourItemName } from "./style";

interface WinePrimaryFlavoursProps {
  wine: WineType | null | undefined;
}

const WinePrimaryFlavours = ({ wine }: WinePrimaryFlavoursProps) => {
  const { t } = useTranslation([I18N_NAMESPACES.WINE_PAGES]);
  const flavours = wine?.flavours || [];
  const fruits = wine?.fruits || [];
  const itemNameCompare = (one: FruitType | FlavourType, other: FruitType | FlavourType) =>
    one?.name.localeCompare(other?.name);
  const sortedFlavours = flavours.sort(itemNameCompare);
  const sortedFruits = fruits.sort(itemNameCompare);

  const items: Array<FruitType | FlavourType> = [...sortedFruits, ...sortedFlavours];

  const numberOfItems = items?.length || 0;
  const numberOfGroups = Math.ceil(numberOfItems / WINE_FLAVOURS_ITEMS_PER_ROW);
  const groupedFlavours = new Array(numberOfGroups)
    .fill(0)
    .map((_, index) =>
      items.slice(index * WINE_FLAVOURS_ITEMS_PER_ROW, (index + 1) * WINE_FLAVOURS_ITEMS_PER_ROW)
    );

  const renderFlavourItem = (item: FlavourType | FruitType): ReactElement => {
    const imageUrl = item?.imageSmallUrl || flavourImagePlaceholder;

    return (
      <FlavourItem key={item?.name}>
        <FlavourItemImage src={imageUrl} isPlaceholder={!item?.imageSmallUrl} />
        <FlavourItemName>{item?.name}</FlavourItemName>
      </FlavourItem>
    );
  };

  return (
    <>
      <SectionTitle>{t("winePages:primaryFlavours")}</SectionTitle>
      <FlavourItemsWrapper>
        {groupedFlavours.map((flavourGroup: Array<FlavourType | FruitType>) =>
          flavourGroup.map(renderFlavourItem)
        )}
      </FlavourItemsWrapper>
    </>
  );
};

export default WinePrimaryFlavours;
